import moduleCallCenterWorkerStats from '../../submodules/motivateWorkerStats'
import moduleConfig from '../../reusablemodules/config'
import {callCenterVars} from '../../../constants/vuexVariables'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import state from './state'

const moduleCallCenter = {
  namespaced: true,
  state () {
    return state
  },
  actions: actions,
  mutations: mutations,
  getters: getters,
  modules: {
    config: moduleConfig,
    callCenterStats: moduleCallCenterWorkerStats('call_center', 'call_center')
  }
}

export default moduleCallCenter



// WEBPACK FOOTER //
// ./src/vuex/modules/callCenter/callCenter.js